import styled from "styled-components/macro";
import { CircularProgress } from "@mui/material";
import { colors } from "assets/styles/colors";

export const StyledProgressCircular = styled(CircularProgress)`
  .MuiCircularProgress-circle {
    color: ${colors.primary};
  }
`;
